const fallbackCopyTextToClipboard = (text: string) => {
  const textAreaElement = document.createElement('textarea');
  textAreaElement.value = text;

  textAreaElement.setAttribute('readonly', '');
  textAreaElement.style.left = '0';
  textAreaElement.style.top = '0';
  textAreaElement.style.position = 'fixed';
  textAreaElement.style.opacity = '0';
  textAreaElement.style.width = '1px';
  textAreaElement.style.height = '0';

  document.body.appendChild(textAreaElement);
  textAreaElement.focus();
  textAreaElement.select();

  try {
    const result = document.execCommand('copy');
    document.body.removeChild(textAreaElement);
    return result;
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
    document.body.removeChild(textAreaElement);
  }

  return false;
};

export const copyTextToClipboard = (text: string, callback?: () => void) => {
  if (!navigator.clipboard) {
    const result = fallbackCopyTextToClipboard(text);
    if (result && callback) return callback();
  } else {
    return navigator.clipboard.writeText(text).then(callback, error => {
      console.error('Could not copy text: ', error);
    });
  }
};

export default copyTextToClipboard;
